// extracted by mini-css-extract-plugin
export var active = "hs-link-hs-module--active--b2077";
export var copytext = "hs-link-hs-module--copytext--2a2a6";
export var darkBackground = "hs-link-hs-module--dark-background--af53c";
export var hsLink = "hs-link-hs-module--hs-link--3b2ec";
export var standard = "hs-link-hs-module--standard--f4fe3";